import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import * as yup from 'yup';

import { resetPassword } from '../../../api/services/Auth';
import { useToastStore } from '../../../shared/stores/toastStore';
import { ChangePasswordForm } from '../../features/ChangePasswordForm';
import { LoginTemplate } from '../../features/Login/LoginTemplate';

const ChangePassword: React.FC = () => {
  const navigate = useNavigate();
  const { addToast } = useToastStore();
  const [searchParams, setSearchParams] = useSearchParams();
  const [resetPasswordToken, setResetPasswordToken] = useState<string>('');

  const schema = yup.object().shape({
    password: yup.string().min(8).max(32).required(),
    password_confirmation: yup.string().oneOf([yup.ref('password'), null], 'passwords must match'),
  });

  useEffect(() => {
    if (searchParams.has('reset_password_token')) {
      const resetToken = searchParams.get('reset_password_token');

      setResetPasswordToken(resetToken !== null ? resetToken : '');
      searchParams.delete('reset_password_token');

      setSearchParams(searchParams);
    }
  }, []);

  const changePassword = async (data, e) => {
    e.preventDefault();
    const response = await resetPassword({
      reset_password_token: resetPasswordToken,
      ...data,
    });

    if (response?.type === 'success') {
      setResetPasswordToken('');
      navigate('/login');
      addToast({ severity: 'info', message: response.data.message });
    } else {
      response.error.errors.forEach((error) => addToast({ severity: 'error', message: error }));
    }
  };

  return (
    <LoginTemplate banner={false}>
      <ChangePasswordForm handleChangePassword={changePassword} validationSchema={schema} />
    </LoginTemplate>
  );
};

export default ChangePassword;
